import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { HeadCell } from "./userAppShared";

const UserAppOrdersTab = ({ orders }: { orders?: any[] }) => {
  const { t } = useTranslation();
  const na = t("user_app.na");

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <HeadCell>{t("user_app.orders.order_number")}</HeadCell>
            <HeadCell>{t("user_app.orders.date")}</HeadCell>
            <HeadCell>{t("user_app.orders.status")}</HeadCell>
            <HeadCell>{t("user_app.orders.items")}</HeadCell>
            <HeadCell align="right">{t("user_app.orders.amount")}</HeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders?.map((order: any, index: number) => (
            <TableRow key={index}>
              <TableCell>
                {order.order_number || t("user_app.orders.order_fallback", { n: index + 1 })}
              </TableCell>
              <TableCell>
                {order.created_date ? new Date(order.created_date).toLocaleDateString() : na}
              </TableCell>
              <TableCell>
                <Chip
                  label={order.status || t("user_app.orders.pending")}
                  size="small"
                  color={order.status === "Completed" ? "success" : "default"}
                />
              </TableCell>
              <TableCell>
                {order.items ? (
                  typeof order.items === "string" ? (
                    order.items
                  ) : (
                    <Box>
                      {order.items.service && (
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {order.items.service}
                        </Typography>
                      )}
                      {order.items.quantity && (
                        <Typography variant="body2" color="text.secondary">
                          {t("user_app.orders.qty", { value: order.items.quantity })}
                        </Typography>
                      )}
                      {order.items.stylist && (
                        <Typography variant="body2" color="text.secondary">
                          {t("user_app.orders.stylist", { value: order.items.stylist })}
                        </Typography>
                      )}
                      {order.items.note && (
                        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                          {t("user_app.orders.note", { value: order.items.note })}
                        </Typography>
                      )}
                    </Box>
                  )
                ) : (
                  na
                )}
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: "bold" }}>
                ${order.total?.toFixed(2) || "0.00"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserAppOrdersTab;
